import classNames from 'classnames';
import React from 'react';
import "./index.less";
var Loading = function Loading(props) {
  var size = props.size,
    showLoading = props.showLoading,
    loadingIcon = props.loadingIcon,
    tip = props.tip,
    className = props.className,
    style = props.style,
    children = props.children;

  // 渲染loading icon和tips
  var renderLoadingIconAndTips = function renderLoadingIconAndTips(loadingIcon, tip) {
    return /*#__PURE__*/React.createElement("div", {
      className: "iron-loading-wrapper"
    }, loadingIcon !== null && loadingIcon !== void 0 ? loadingIcon : /*#__PURE__*/React.createElement("div", {
      className: "iron-loading-icon ".concat(size !== undefined ? size : '')
    }), tip && /*#__PURE__*/React.createElement("div", {
      className: "iron-loading-tips"
    }, " ", tip));
  };

  //当有children的时候，渲染一个遮罩
  var renderLoading = function renderLoading(loadingIcon, tip) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "iron-loading-icon-container"
    }), renderLoadingIconAndTips(loadingIcon, tip));
  };
  var classes = classNames('iron-loading', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    style: style
  }, showLoading && /*#__PURE__*/React.createElement(React.Fragment, null, children ? renderLoading(loadingIcon, tip) : renderLoadingIconAndTips(loadingIcon, tip)), children);
};
Loading.defaultProps = {
  showLoading: true //默认显示loading
};
export default Loading;